import React, { useState, useEffect } from 'react';
import api from '../../../utils/api';

const EmailSmtpSetup = ({ onStatusChange }) => {
  const [smtpConfig, setSmtpConfig] = useState({
    host: '',
    port: 587,
    secure: false,
    user: '',
    password: '',
    fromName: ''
  });
  const [status, setStatus] = useState(null); // 'connected' | 'disconnected'
  const [senderEmail, setSenderEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    try {
      const res = await api('/email-automation/status');
      if (!res.ok) throw new Error('Failed to fetch status');
      const data = await res.json();
      
      if (data.configured) {
        setStatus('connected');
        setSenderEmail(data.senderEmail);
        if (onStatusChange) onStatusChange(true);
      } else {
        setStatus('disconnected');
        if (onStatusChange) onStatusChange(false);
      }
    } catch (err) {
      console.error(err);
      setStatus('disconnected');
      if (onStatusChange) onStatusChange(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSmtpConfig(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSaveAndTest = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api('/email-automation/connect', {
        method: 'POST',
        body: smtpConfig
      });
      const data = await res.json();
      
      if (res.ok && data.success) {
        setStatus('connected');
        setSenderEmail(smtpConfig.user);
        if (onStatusChange) onStatusChange(true);
        alert('SMTP Configured and Tested Successfully!');
      } else {
        setError(data.message || 'Failed to connect');
      }
    } catch (err) {
      setError(err.message || 'Failed to connect');
    } finally {
      setLoading(false);
    }
  };

  if (status === 'connected') {
    return (
      <div style={{ padding: '16px', background: '#dcfce7', borderRadius: '8px', border: '1px solid #86efac', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#166534', marginBottom: '8px' }}>🟢 SMTP Connected</h3>
        <p style={{ color: '#15803d' }}>Emails will be sent from: <strong>{senderEmail}</strong></p>
        <button 
          onClick={() => setStatus('disconnected')}
          style={{ marginTop: '12px', padding: '6px 12px', background: 'white', border: '1px solid #86efac', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', color: '#166534' }}
        >
          Reconfigure SMTP
        </button>
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', background: 'white', borderRadius: '12px', border: '1px solid var(--color-border-primary)', marginBottom: '24px' }}>
      <h3 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>🔴 SMTP Not Configured</h3>
      <p style={{ color: 'var(--color-text-secondary)', marginBottom: '16px' }}>Please configure your SMTP settings to send emails. For Gmail, use an App Password.</p>
      
      {error && <div style={{ color: 'red', marginBottom: '16px' }}>{error}</div>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>SMTP Host</label>
          <input type="text" name="host" value={smtpConfig.host} onChange={handleChange} placeholder="e.g. smtp.gmail.com" style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--color-border-primary)' }} />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Port</label>
          <input type="number" name="port" value={smtpConfig.port} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--color-border-primary)' }} />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Email (Username)</label>
          <input type="email" name="user" value={smtpConfig.user} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--color-border-primary)' }} />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Password (App Password)</label>
          <input type="password" name="password" value={smtpConfig.password} onChange={handleChange} style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--color-border-primary)' }} />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>From Name</label>
          <input type="text" name="fromName" value={smtpConfig.fromName} onChange={handleChange} placeholder="e.g. John Doe" style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid var(--color-border-primary)' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '32px' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
            <input type="checkbox" name="secure" checked={smtpConfig.secure} onChange={handleChange} />
            <span style={{ fontSize: '14px', fontWeight: '500' }}>Secure (SSL/TLS) - usually true for 465</span>
          </label>
        </div>
      </div>

      <button 
        onClick={handleSaveAndTest}
        disabled={loading}
        style={{ padding: '12px 24px', background: 'var(--color-brand-primary)', color: 'white', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', border: 'none', opacity: loading ? 0.7 : 1 }}
      >
        {loading ? 'Testing & Saving...' : 'Save & Test Connection'}
      </button>
    </div>
  );
};

export default EmailSmtpSetup;
